"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeErrorConstants = void 0;
exports.TradeErrorConstants = {
    unknownError(code, msg, $st) {
        return $st("trade_error_unknown") + " code: " + code + ". msg: " + msg;
    },
    networkError($st) {
        return $st("network_error");
    },
    inputPrice($st) {
        return $st("trade_error_input_price");
    },
    inputTriggerPrice($st) {
        return $st("trailing_stop_limit_error_input_trigger_price");
    },
    inputTrailingPercent($st) {
        return $st("trailing_stop_limit_error_input_trailing_percent");
    },
    inputQuantity($st) {
        return $st("trade_error_input_quantity");
    },
    inputGridCount($st) {
        return $st("trade_error_input_grid_count");
    },
    inputPriceRange($st) {
        return $st("trade_please_input_price_range");
    },
    priceTooHigh(standard, $st) {
        return $st("trade_error_price_too_high", { price: standard });
    },
    priceTooLow(standard, $st) {
        return $st("trade_error_price_too_low", { price: standard });
    },
    lowAmount(min, $st) {
        return $st("trade_error_low_amount", { amount: min });
    },
    lowCost(min, $st) {
        return $st("trade_error_low_cost", { cost: min });
    },
    balanceNotEnough($st) {
        return $st("trade_error_balance_not_enough");
    },
    gridHasPending($st) {
        return $st("grid_create_error_has_pending");
    },
    gridTooManyMicroOrder($st) {
        return $st("grid_create_error_too_many_micro_order");
    },
    gridTooManyRow($st) {
        return $st("grid_create_error_too_many_row");
    },
    gridTooManyOneKey($st) {
        return $st("grid_create_error_too_many_one_key");
    },
    insufficientBalance($st) {
        return $st("trade_create_order_insufficient_balance");
    },
    lessThanMinQuantity($st) {
        return $st("trade_create_order_less_than_min_quantity");
    },
    girdAmountPercentRatherThan95($st) {
        return $st("trade_grid_ai_percent_95");
    },
    gridAIParamsWrong($st) {
        return $st("trade_error_grid_ai_params_wrong");
    },
    gridLowNeedLowerThanHigh($st) {
        return $st("trade_error_grid_low_need_lower_than_high");
    },
    gridStopNeedLowerThanLow($st) {
        return $st("trade_error_grid_low_need_lower_than_high");
    },
    gridCheckPriceRange($st) {
        return $st("grid_param_wrong");
    },
    stopCannotHighThanCurrentPrice($st) {
        return $st("grid_stop_high_ticker");
    },
    gridCount99RangeError($st) {
        return $st("trade_error_grid_count_range_error");
    },
    inputGridPerVolume($st) {
        return $st("trade_error_input_grid_per_volume");
    },
    inputGridPerProfitRate($st) {
        return $st("trade_error_input_grid_per_profit_rate");
    },
    inputInvest($st) {
        return $st("trade_error_input_invest");
    },
    inputLow($st) {
        return $st("trade_error_input_low");
    },
    gridPerVolumeHitAmountMin($st) {
        return $st("trade_error_per_volume_hit_amount_min");
    },
    gridPriceTooSmall($st) {
        return $st("trade_error_grid_price_too_small");
    },
    gridPriceRangeTooLarge($st) {
        return $st("trade_error_grid_price_hit_price_min");
    },
    gridCostHitCostMin($st) {
        return $st("trade_error_grid_cost_hit_cost_min");
    },
    gridDuplicateGrid($st) {
        return $st("trade_error_duplicate_grid");
    },
    gridUnknownError($st) {
        return $st("trade_grid_error_unknown");
    },
    gridExchangeBusy($st) {
        return $st("trade_error_grid_exchange_busy");
    },
    gridSignFailed($st) {
        return $st("trade_grid_error_sign_failed");
    },
    gridPriceTooHigh($st) {
        return $st("trade_grid_error_price_too_high");
    },
    gridBalanceOrderBuyTip(buyQuantity, $st) {
        return $st("trade_grid_balance_order_buy", { info: buyQuantity });
    },
    gridBalanceOrderSellTip(sellQuantity, $st) {
        return $st("trade_grid_balance_order_sell", { info: sellQuantity });
    },
    quoteNotEnough(quote, $st) {
        return $st("grid_err_error_balance_not_enough_quote", { quote: quote });
    },
    baseNotEnough(base, $st) {
        return $st("grid_err_error_balance_not_enough_base", { base: base });
    },
    igTradingRateRangeWrong(min, $st) {
        return $st("ig_trading_rate_range_error", { min: min });
    },
    gridFutureHasSameSymbolOpeningOrder($st) {
        return $st("grid_future_has_same_symbol_opening_order");
    },
    tradeCostGreaterThanLeverageAmount($st, amount) {
        return $st("trade_cost_than_leverage_amount", { amount: amount });
    },
    tradeCostGreaterThanLeveragePairLimit($st, amount) {
        return $st("trade_cost_than_leverage_pair_limit", { amount: amount });
    }
};
